const HeroVariant2 = ({ theme, font, editableData = {}, renderEditable }) => {
  const getText = (key, defaultValue) => {
    const value = editableData[key];
    return typeof value === 'string' ? value : value?.text || defaultValue;
  };

  return (
    <div className="min-h-screen flex items-center p-8" style={{ backgroundColor: theme.backgroundColor, fontFamily: font.mainText }}>
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h1 className="text-4xl md:text-6xl font-bold mb-6" style={{ color: theme.primaryColor }}>
            {renderEditable ? renderEditable("heading", getText("heading", "Transform Your Digital Presence")) : getText("heading", "Transform Your Digital Presence")}
          </h1>
          <p className="text-lg mb-8" style={{ color: theme.textColor }}>
            {renderEditable ? renderEditable("subheading", getText("subheading", "Enterprise-grade solutions for modern businesses. Scale effortlessly with our intuitive platform.")) : getText("subheading", "Enterprise-grade solutions for modern businesses. Scale effortlessly with our intuitive platform.")}
          </p>
          <button
            className="px-8 py-4 rounded-xl text-lg font-semibold hover:shadow-lg transition-all"
            style={{
              backgroundColor: theme.primaryColor,
              color: theme.backgroundColor
            }}
          >
            {renderEditable ? renderEditable("primaryButton", getText("primaryButton", "Start Free Trial")) : getText("primaryButton", "Start Free Trial")}
          </button>
        </div>
        <div className="flex justify-center">
          <div className="w-full h-80 rounded-2xl border-2 border-dashed flex items-center justify-center"
            style={{ borderColor: theme.primaryColor }}>
            <span style={{ color: theme.primaryColor }}>
              {renderEditable ? renderEditable("imagePlaceholder", getText("imagePlaceholder", "Hero Image")) : getText("imagePlaceholder", "Hero Image")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroVariant2;
